import ForgetPasswordForm from "../../features/authentication/newPassword/ForgetPasswordForm";

function ForgetPassword() {
  return (

    <main className="container mx-auto">
      <ForgetPasswordForm />
    </main>
  );
}

export default ForgetPassword;
